﻿export interface QuestionnaireProgress {
  latestVisitedQuestionnaireStepCode: string;
  furthestQuestionnaireStepCode: string;
}

export function copyQuestionnaireProgress(progress: QuestionnaireProgress): QuestionnaireProgress {
  return {
    furthestQuestionnaireStepCode: progress.furthestQuestionnaireStepCode,
    latestVisitedQuestionnaireStepCode: progress.latestVisitedQuestionnaireStepCode,
  };
}
